import {AfterViewInit, Component, ContentChild, Directive, ElementRef, Input, OnInit} from '@angular/core';

/**
 * Required to use ContentChild decorator for panel-header attribute in PanelComponent
 */
@Directive({
  selector: '[panel-header]'
})
export class PanelHeaderDirective {
}

/**
 * If panel-header is omitted, no header is shown.
 *
 * Usage:
 * ```
 * <app-panel>
 *   <div panel-header>
 *     header content
 *   </div>
 *   <div panel-content>
 *     content
 *   </div>
 * </app-panel>
 * ```
 */
@Component({
  selector: 'app-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.scss']
})
export class PanelComponent implements OnInit {
  /**
   * @deprecated
   */
  @Input() public showHeader = true;

  @ContentChild(PanelHeaderDirective, {read: ElementRef}) public panelHeaderRef: ElementRef<HTMLElement>;

  constructor() { }

  ngOnInit(): void {
  }
}
